<span #mySpan>
    {{ this.value }}
    <p-sortIcon field="{{ field }}"></p-sortIcon>
</span>
